export default __webpack_public_path__ + "static/media/student-login-.b23cf632.png";